__turbopack_context__.v({
  "bodyLBoldFlat": "HKRzIq_bodyLBoldFlat",
  "bodyLBoldLoose": "HKRzIq_bodyLBoldLoose",
  "bodyLBoldSnug": "HKRzIq_bodyLBoldSnug",
  "bodyLBoldTight": "HKRzIq_bodyLBoldTight",
  "bodyLRegularFlat": "HKRzIq_bodyLRegularFlat",
  "bodyLRegularLoose": "HKRzIq_bodyLRegularLoose",
  "bodyLRegularSnug": "HKRzIq_bodyLRegularSnug",
  "bodyLRegularTight": "HKRzIq_bodyLRegularTight",
  "bodyMBoldFlat": "HKRzIq_bodyMBoldFlat",
  "bodyMBoldLoose": "HKRzIq_bodyMBoldLoose",
  "bodyMBoldSnug": "HKRzIq_bodyMBoldSnug",
  "bodyMBoldTight": "HKRzIq_bodyMBoldTight",
  "bodyMRegularFlat": "HKRzIq_bodyMRegularFlat",
  "bodyMRegularLoose": "HKRzIq_bodyMRegularLoose",
  "bodyMRegularSnug": "HKRzIq_bodyMRegularSnug",
  "bodyMRegularTight": "HKRzIq_bodyMRegularTight",
  "bodySBoldFlat": "HKRzIq_bodySBoldFlat",
  "bodySBoldLoose": "HKRzIq_bodySBoldLoose",
  "bodySBoldSnug": "HKRzIq_bodySBoldSnug",
  "bodySBoldTight": "HKRzIq_bodySBoldTight",
  "bodySRegularFlat": "HKRzIq_bodySRegularFlat",
  "bodySRegularLoose": "HKRzIq_bodySRegularLoose",
  "bodySRegularSnug": "HKRzIq_bodySRegularSnug",
  "bodySRegularTight": "HKRzIq_bodySRegularTight",
  "bodyXsBoldFlat": "HKRzIq_bodyXsBoldFlat",
  "bodyXsBoldLoose": "HKRzIq_bodyXsBoldLoose",
  "bodyXsBoldSnug": "HKRzIq_bodyXsBoldSnug",
  "bodyXsBoldTight": "HKRzIq_bodyXsBoldTight",
  "bodyXsRegularFlat": "HKRzIq_bodyXsRegularFlat",
  "bodyXsRegularLoose": "HKRzIq_bodyXsRegularLoose",
  "bodyXsRegularSnug": "HKRzIq_bodyXsRegularSnug",
  "bodyXsRegularTight": "HKRzIq_bodyXsRegularTight",
  "displayARegular": "HKRzIq_displayARegular",
  "displayBRegular": "HKRzIq_displayBRegular",
  "displayCRegular": "HKRzIq_displayCRegular",
  "displayDRegular": "HKRzIq_displayDRegular",
  "displayERegular": "HKRzIq_displayERegular",
  "displayFRegular": "HKRzIq_displayFRegular",
  "displayGRegular": "HKRzIq_displayGRegular",
  "displayHRegular": "HKRzIq_displayHRegular",
  "displayIRegular": "HKRzIq_displayIRegular",
  "displayJRegular": "HKRzIq_displayJRegular",
  "typography": "HKRzIq_typography",
});
